import { useApiFetcherSWR } from "../../../hooks/SwrCustom";


const API_ENDPOINT = {

    GET_SUBSTITUTER_SEARCH_LIST: {
        url: "get-sub-request-search-form-list-by-type?type=substitute",
        method: "get",
    },

    GET_USER_SUBSTITUTION_INFO: {
        url: ({ id, substitutionId }) => `users/${id}/${substitutionId}`,
        method: "get",
    },

    GET_RECIPIENTS_LIST: {
        url: (id) => `verzoeken/scherm/recipients-list/${id}`,
        method: "get",
    },

    GET_DOC_TYPES: {
        url: "doc/types",
        method: "get",
    },



    GET_SCHOOLS_BY_COMMUNITY: {
        url: (communityId, isCoordinator) =>
            `${isCoordinator ? "schools" : "schools-list"}?iCommunityId=${communityId}`,
        method: "get",
    },

    GET_ABSENCE_CODES_BY_COMMUNITY: {
        url: (communityId) => `absence-codes-list?iCommunityId=${communityId}`,
        method: "get",
    },

    GET_GROUPS_BY_COMMUNITY: {
        url: (communityId) => `groups-list?iCommunityId=${communityId}`,
        method: "get",
    },

    GET_MELDER_LIST: {
        url: (schoolId, communityId) =>
            `melder/list/${schoolId}/${communityId}`,
        method: "get",
    },

    GET_DOC_TYPES: {
        url: "doc/types",
        method: "get",
    },

    GET_COMMUNITY_LIST: {
        url: (adminId = "") =>
            adminId
                ? `communityList?iAdminId=${adminId}`
                : "communityList",
        method: "get",
    },

    // ---------------- POST ----------------

    UPDATE_DAGDELEN: {
        url: "verzoeken/update-dagdelen",
        method: "post",
    },

    SEND_EMAIL_CODE: {
        url: "send-email-code",
        method: "post",
    },

    DISABLE_EMAIL_CODE: {
        url: "2fa/send-disable-email-code",
        method: "get",
    },
    

    SEND_INFO: {
        url: "verzoeken/scherm/send-info",
        method: "post",
    },

    SAVE_DOCUMENT: {
        url: "save-document",
        method: "post",
    },

    SAVE_USER_DOCUMENT: {
        url: "gebruiker/save-document",
        method: "post",
    },

    VALIDATE_ADDRESS: {
        url: "address/validate",
        method: "post",
    },

    SAVE_ADDRESS: {
        url: "address/save",
        method: "post",
    },

    CALCULATE_DISTANCE: {
        url: "travelcost/calculate-distance",
        method: "post",
    },
};

// ==================== GET HOOKS ====================

export const useSubstituterSearchList = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_SUBSTITUTER_SEARCH_LIST);

export const useUserSubstitutionInfo = ({
    id,
    substitutionId,
    shouldFetch = true,
}) =>
    useApiFetcherSWR(
        shouldFetch && id && substitutionId
            ? {
                ...API_ENDPOINT.GET_USER_SUBSTITUTION_INFO,
                url: API_ENDPOINT.GET_USER_SUBSTITUTION_INFO.url({
                    id,
                    substitutionId,
                }),
            }
            : null
    );

export const useRecipientsList = ({
    substitutionId,
    shouldFetch = true,
    polling = false,
}) =>
    useApiFetcherSWR(
        shouldFetch && substitutionId
            ? {
                ...API_ENDPOINT.GET_RECIPIENTS_LIST,
                url: API_ENDPOINT.GET_RECIPIENTS_LIST.url(substitutionId),
            }
            : null,
        {
            refreshInterval: polling ? 10000 : 0,
        }
    );

export const useSchoolsByCommunity = ({
    communityId,
    isCoordinator,
    shouldFetch = true,
}) =>
    useApiFetcherSWR(
        shouldFetch && communityId
            ? {
                ...API_ENDPOINT.GET_SCHOOLS_BY_COMMUNITY,
                url: API_ENDPOINT.GET_SCHOOLS_BY_COMMUNITY.url(
                    communityId,
                    isCoordinator
                ),
            }
            : null
    );

export const useAbsenceCodesByCommunity = ({
    communityId,
    shouldFetch = true,
}) =>
    useApiFetcherSWR(
        shouldFetch && communityId
            ? {
                ...API_ENDPOINT.GET_ABSENCE_CODES_BY_COMMUNITY,
                url: API_ENDPOINT.GET_ABSENCE_CODES_BY_COMMUNITY.url(
                    communityId
                ),
            }
            : null
    );

export const useGroupsByCommunity = ({
    communityId,
    shouldFetch = true,
}) =>
    useApiFetcherSWR(
        shouldFetch && communityId
            ? {
                ...API_ENDPOINT.GET_GROUPS_BY_COMMUNITY,
                url: API_ENDPOINT.GET_GROUPS_BY_COMMUNITY.url(communityId),
            }
            : null
    );

export const useMelderList = ({
    schoolId,
    communityId,
    shouldFetch = true,
}) =>
    useApiFetcherSWR(
        shouldFetch && schoolId && communityId
            ? {
                ...API_ENDPOINT.GET_MELDER_LIST,
                url: API_ENDPOINT.GET_MELDER_LIST.url(
                    schoolId,
                    communityId
                ),
            }
            : null
    );

export const useDocTypes = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_DOC_TYPES);

export const useCommunityList = (adminId = "") =>
    useApiFetcherSWR({
        ...API_ENDPOINT.GET_COMMUNITY_LIST,
        url: API_ENDPOINT.GET_COMMUNITY_LIST.url(adminId),
    });

// ==================== POST HOOKS ====================

export const useUpdateDagdelen = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_DAGDELEN);

export const useSendEmailCode = () =>
    useApiFetcherSWR(API_ENDPOINT.SEND_EMAIL_CODE);

export const useDisableEmailCode = (shouldFetch) =>
    useApiFetcherSWR(
        {
            url: "2fa/send-disable-email-code",
            method: "get",
        },
        {
            revalidateOnMount: shouldFetch,
            revalidateIfStale: shouldFetch,
        }
    );

  export const useDisableEmailCodeManual = (shouldFetch) =>
    useApiFetcherSWR(
        shouldFetch
            ? {
                url: "2fa/send-disable-email-code",
                method: "get",
            }
            : null
    );

export const useSendInfo = () =>
    useApiFetcherSWR(API_ENDPOINT.SEND_INFO);

export const useSaveDocument = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_DOCUMENT);

export const useSaveUserDocument = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_USER_DOCUMENT);

export const useValidateAddress = () =>
    useApiFetcherSWR(API_ENDPOINT.VALIDATE_ADDRESS);

export const useSaveAddress = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_ADDRESS);

export const useCalculateDistance = () =>
    useApiFetcherSWR(API_ENDPOINT.CALCULATE_DISTANCE);

export default API_ENDPOINT;